import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './datasets-edit-view-or-folder.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import principals from 'scoreboard/components/principals'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import conductor from 'scoreboard/components/conductor'
import user from 'scoreboard/components/user'
import i18n from 'scoreboard/components/i18n'
import noPermission from 'scoreboard/components/no-permission.hbs'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import BaseDatasetsEditView from './base-datasets-edit-view'
import datasetsTabs from '../datasets-tabs.hbs'
import { toggleAdvancedPermission } from './permissions-panel'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'

var DatasetsEditViewOrFolder = BaseDatasetsEditView.extend({

	/**
	 * The Datasets Edit tab for dataset folders and dataset views
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Dataset} options.relative the dataset, folder or view _relative_
	 * to which this view or folder will be added
	 *
	 * @param options.viewEditTabs the handlebars template used to render the view and
	 * edit tabs
	 *
	 * @param {String} options.overviewTabCode a message code to display as the title of the
	 * Overview tab
	 */
	initialize: function(options) {
		BaseDatasetsEditView.prototype.initialize.apply(this, arguments)
		// Check if we're creating a new folder and initialize the label accordingly
		if (this.isNewFolder()) {
			this.model.set('label', i18n.get('common.newFolder'))
		}
	},

	tagName: 'form',

	className: 'datasets-edit-view-or-folder table-hack display-layout',

	events: {
		'click .cancel': 'onClickCancel'
	},

	/** @type {Dataset} */
	model: null,

	createFormView: function() {
		this.formView = new this.FormViewClass({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: () => this.isNewFolder()
		})
	},

	render: function({ instadone } = {}) {
		this.removeComponents()
		this.prepHeader()

		let everyoneMessageCode = 'datasets.permissions.everyone'
		if (this.isFolder()) {
			everyoneMessageCode += '.org'
		}
		let type = this.model.get('type') === 'view' ?
			'common.view' : 'datasets.folder'
		const body = template({
			label: this.model.get('label'),
			everyoneLabel: i18n.get(everyoneMessageCode,
				i18n.get(`datasets.${this.model.get('type')}`).toLowerCase()),
			rootId: this.model.get('rootDatasetId'),
			type: _.lowerCase(i18n.get(type))
		})
		this.$el.empty().append(this.header.render().el, body)

		this.renderPermissions()
		this.renderEditButtons()
		this.renderLabelField()

		if (this.model.get('type') === 'view') {
			// not implemented yet
			this.$('.move-copy').addClass('is-not-displayed')
		} else {
			// only show the move button for folders
			this.$('.copy').addClass('is-not-displayed')
			this.$('.move').removeClass('button-left-joined')
		}

		this.secure()

		this.formView.start({
			isNew: this.model.isNew(),
			instadone
		})

		if (this.isNewFolder()) {
			// Pre-select the label field so users can start typing right away
			this.$('[name=label]').select()
		}

		return this
	},

	prepHeader: function() {
		var tabs = this.isFolder() ?
			viewEditTabs : datasetsTabs
		var tabContext = {
			id: this.model.id || this.model.get('parentId') || this.model.get('relativeId'),
			section: this.model.section,
			overviewTabCode: 'common.view'
		}
		// the model will only be new if we're creating a folder.  Dataset views
		// are created on the Overview tab so this form never displays a new
		// dataset view
		var heading = this.model.isNew() ?
			i18n.get('common.create2', 'bookmarks.folder') :
			this.model.get('label')
		this.header = new DisplayHeader({
			heading: heading,
			model: this.model,
			subsection: 'edit',
			tabs: tabs(tabContext)
		})
	},

	renderPermissions: function() {
		if (this.handlePermissionsElsewhere()) return

		let principals = _(this.ownPermissions())
			.map('principal')
			// for unit tests
			.filter(p => !_.isUndefined(p))
			.value()
		this.renderPrincipalPanel(principals)
	},

	/**
	 * If we find a permission that's not associated with this dataset or the
	 * root, that means permissions are specified on an ancestor and can't
	 * be changed on this dataset
	 */
	handlePermissionsElsewhere: function() {
		this.permissionElsewhere = _.find(this.model.get('permissions'), permission =>
			permission.datasetId != this.model.id &&
			permission.datasetId != this.model.get('rootDatasetId'))

		if (this.permissionElsewhere) {
			var link =
				'<a class="sp-navigate text-link" href="datasets/' + this.permissionElsewhere.datasetId + '/edit">' +
					_.escape(this.model.get('permissionsLabel')) +
				'</a>'
			this.$('.permissions-message').removeClass('is-not-displayed')
				.html(i18n.get('datasets.permissions.elsewhere', link))
			this.$('.permissions').remove()
		}

		return this.permissionElsewhere
	},

	renderPrincipalPanel: function(principals) {
		this._renderCustomToggle(principals)
		this.principalPanel = new PrincipalPanel({
			el: this.$('.principal-panel'),
			placeholderKey: 'admin.group.addUserGroup',
			currentPrincipals: principals
		}).render()
		this.principalPanel.on('change', this.formView.change.bind(this.formView))
		this._onChangeAdvancedPermission()
	},

	/**
	 * Let's user toggle between default org permission or advanced permissions
	 * @private
	 */
	_renderCustomToggle: function (principals) {
		this.advancedPermissionsToggle = new OnOffToggle({
			name: 'advancedPermissionsToggle',
			checked: !_.isEmpty(principals),
			label: i18n.get('datasets.permissions.advanced')
		})
		this.listenTo(this.advancedPermissionsToggle, 'change', this._onChangeAdvancedPermission.bind(this))
		this.$('.panel-header').prepend(this.advancedPermissionsToggle.el)
		this.advancedPermissionsToggle.render()
	},

	renderEditButtons: function() {
		this.buttons = new EditButtons({
			el: this.$('.edit-buttons'),
			model: this.model,
			section: 'datasets'
		}).render()

		// #55613
		// Copying should not be enabled for dataset folders
		if (this.isFolder()) {
			this.buttons.$('.copy').remove()
		}
	},

	renderLabelField: function() {
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()
	},

	secure: function() {
		if (!this.model.isViewRecords()) {
			this.$('.records-tab').remove()
		}

		let panelsRemoved = 0
		if (!this.model.isNew() && !this.model.isEditable()) {
			this.$('.label-panel, .delete-container, move-copy').remove()
			panelsRemoved++
		}
		if (this.model.shouldHidePermissions(this.options)) {
			this.$('.banner, .permissions').remove()
			panelsRemoved++
		}
		if (panelsRemoved == 2) {
			let type = this.model.getTypeDescription().toLowerCase()
			let message = i18n.get('common.security.missing.datasets.edit', type)
			let context = { message, hideContactAdminMessage: true }
			this.$('.scroll-container').html(noPermission(context))
			this.$('.edit-buttons').remove()
		}

		// #15952 don't allow the user to delete themself
		_.each($('.principal-item'), el => {
			el = $(el)
			let data = el.data()
			if (data.id == user.model.id && data.type === 'user') {
				el.find('.delete').addClass('is-not-displayed')
			}
		})
	},

	_onChangeAdvancedPermission: function() {
		toggleAdvancedPermission(this, this.principalPanel)
	},

	submit: function() {
		// Toggle won't be created if permissions are managed at a higher level
		const advancedPermission = _.invoke(this.advancedPermissionsToggle, 'val')

		let datasetPermissions = []
		if (advancedPermission) {
			const permissionByPrincipal = _.keyBy(this.ownPermissions(), p => principals.hashCode(p.principal))
			datasetPermissions = _.map(this.principalPanel.getPrincipals(), principal => {
				return {
					// #37708 need to give the server the permissioId if it was
					// pre-existing so that auditing is accurate
					id: _.get(permissionByPrincipal[principals.hashCode(principal)], 'id'),
					datasetId: this.model.id,
					principal
				}
			})
		}

		let changes = {}
		if (this.model.isNew() || this.model.isModifyView()) {
			changes.label = this.$('[name=label]').val()
		}
		if (!this.permissionElsewhere && this.model.isModifyPermission()) {
			changes.permissions = datasetPermissions
		}
		this.save(changes)
	},

	_saveModel: function(data, event) {
		return this.model.save(data, {
			patch: true,
			success: model => {
				// make sure the datasetId is populated or the UI won't work
				_.each(data.permissions, p => p.datasetId = model.id)
				this.render({ instadone: true }) // #8449 we know the ID for the overview tab now
				this.trigger('save', model)
				this.$('.button-primary').data('view')?.done()
				triggerAddOrEdit(event, model, this.originalModel)
			}
		})
	},

	onClickCancel: function() {
		if (this.model.isNew()) {
			if (conductor.id()) {
				conductor.edit()
			} else {
				var url = 'organizations/' + this.model.get('organizationId') + '/' + this.model.section
				conductor.navigate(url, { trigger: true })
			}
		} else {
			this.render()
		}
	},

	removeComponents: function() {
		_.invokeMap([this.labelField, this.header, this.buttons,
			this.principalPanel, this.advancedPermissionsToggle], 'remove')
	},

	isFolder: function() {
		return this.model.get('type') === 'folder'
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeComponents()
		_.invoke(this.formView, 'remove')
	},

	isNewFolder: function() {
		return this.model.isNew() && this.model.get('type') === 'folder'
	},
})

export default DatasetsEditViewOrFolder

DatasetsEditViewOrFolder.__filename__ = 'datasets/edit/datasets-edit-view-or-folder.js'
